module.exports = __webpack_public_path__ + "static/media/icon-tag-moduleF4.48e244a1.png";